import React, { useEffect } from "react";
// import ToggleButton from '@mui/material/ToggleButton';
// import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Feedback from "./Feedback";
import Button from '@mui/material/Button';
import { Transition } from "./codeHelper";
import { EventEmitter } from "../../event";
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import ThumbDownAltOutlinedIcon from '@mui/icons-material/ThumbDownAltOutlined';

export default function ToggleThumb(props) { 
    const [thumbUp, setThumbUp] = React.useState(undefined);
    const [openFeedbackDialog, setOpenFeedbackDialog] = React.useState(false);


    useEffect(() => {
        if (props.msg && !thumbUp) {

            setData();

        }
    });

    function setData() { 
        setThumbUp(false);
    }
    const handleclick = (val) => {
         setThumbUp(val);
         if (val === false)
            handleClickOpenDialog()


    }
    
    function handleClickOpenDialog() {
        setOpenFeedbackDialog(true);
    }
    const handleCloseFeedbackDialog = () => {
        setOpenFeedbackDialog(false);
    };

    EventEmitter.subscribe("feebackToggle", (event) => {
        setOpenFeedbackDialog(false);
    })

    return (
        <div>
            {thumbUp ?
                <div  >
                    <ThumbUpIcon sx={{ fontSize: '15px' }} onClick={() => handleclick(true)}  className="mr-2"/>
                    <ThumbDownAltOutlinedIcon sx={{ fontSize: '15px' }} onClick={() => handleclick(false)} className=""/>
                </div> :
                <div>{
                    thumbUp !== undefined ?
                        <div> 
                            <ThumbUpAltOutlinedIcon sx={{ fontSize: '15px' }} onClick={() => handleclick(true)} className="mr-2"/>
                            <ThumbDownIcon sx={{ fontSize: '15px' }} onClick={() => handleclick(false)} />
                        </div>
                        :
                        <div>
                            <ThumbUpAltOutlinedIcon sx={{ fontSize: '15px' }} onClick={() => handleclick(true)} className="mr-2"/>
                            <ThumbDownAltOutlinedIcon sx={{ fontSize: '15px' }} onClick={() => handleclick(false)} className=""/>
                        </div>
                }
                </div>
            }
            {/* <ToggleButtonGroup
                value={value}
                exclusive
                onChange={handleValue}
                // onClick={handleclick}
                aria-label="text alignment"
            >
                <ToggleButton value="up" aria-label="left aligned" sx={{ height: '25px', width: '25px' }}>
                    <ThumbUpIcon sx={{ fontSize: '15px' }} />
                </ToggleButton>
                <ToggleButton value="down" aria-label="centered" sx={{ height: '25px', width: '25px' }}>
                    <ThumbDownIcon sx={{ fontSize: '15px' }} />
                </ToggleButton>
            </ToggleButtonGroup> */}
            <Dialog
                fullScreen
                open={openFeedbackDialog}
                onClose={handleCloseFeedbackDialog}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative' }} style={{ background: '#002E98' }}>
                    <Toolbar >
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleCloseFeedbackDialog}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            Feedback
                        </Typography>
                        <Button autoFocus color="inherit" onClick={handleCloseFeedbackDialog}>
                            Close
                        </Button>
                    </Toolbar>
                </AppBar>
                <Feedback diskCode={props.diskCode} type="negativeFeedback" msg={props.msg} />
            </Dialog>
        </div>

    );
}